import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

class ClassSectionService {


    static getStandardsBySection(item) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.getClassSection}`;
        if (item?.standardI) {
            api = `${API_BASE_URL}${API_PATHS.getClassSection}?standardI=${item?.standardI}`;
        }
        if (item?.id) {
            api = `${API_BASE_URL}${API_PATHS.getClassSection}?id=${item?.id}`;
        }
        return axiosInstance
            .get(api, item)
    }


    static addClassandsection(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addClassSection}`;
        return axiosInstance
            .post(api, data)

    }

    static editClassandsection(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editClassSection}`;
        return axiosInstance
            .put(api, data)

    }

}

export default ClassSectionService;
